import { render, staticRenderFns } from "./InternalPage.vue?vue&type=template&id=0ca5047c&scoped=true&"
import script from "./InternalPage.vue?vue&type=script&lang=js&"
export * from "./InternalPage.vue?vue&type=script&lang=js&"
import style0 from "./InternalPage.vue?vue&type=style&index=0&id=0ca5047c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5047c",
  null
  
)

export default component.exports